import { render, staticRenderFns } from "./MarketInvoicesTableType.vue?vue&type=template&id=578c539c&"
import script from "./MarketInvoicesTableType.vue?vue&type=script&lang=js&"
export * from "./MarketInvoicesTableType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports